import SubjectToTaxTypes from '../constants/SubjectToTaxTypes';

const documentTemplate = (currency) => {
  const documentCurrency = currency || 'MXN';

  return {
    documentId: '',
    documentSeries: '',
    documentConsecutive: '',
    documentPreviousBalance: '',
    documentCurrency,
    documentExchangeRate: 1,
    documentPartialityNumber: '',
    documentAmountPaid: '',
    documentOutstandingBalance: '',
    documentInvoiceExchangeRate: null,
    documentConversionAmountPaid: '',
    documentTotal: '',
    documentTaxTransfers: [],
    documentTaxWithholdings: [],
    objectImpDr: '',
  };
};

const completeDocumentTaxes = tax => ({
  ...tax,
  base: 0,
  amount: tax.amount ? 0 : tax.amount,
  previousBase: tax.base,
  previousAmount: tax.amount,
});

function createTransfersDocumentRelated(concepts) {
  const plain = concepts.reduce((accum, { taxTransfers = [] }) => accum.concat(
    taxTransfers.map(({ ...props }) => props),
  ), []);

  const dataTransfers = plain.reduce((accum, tax) => {
    const index = accum.findIndex(
      currentTax => currentTax.tax === tax.tax && currentTax.fee === tax.fee,
    );

    if (index >= 0) {
      const taxItem = accum[index];

      const amount = parseFloat(taxItem.amount || 0) + parseFloat(tax.amount || 0);
      const base = parseFloat(taxItem.base || 0) + parseFloat(tax.base || 0);

      accum[index].amount = amount;
      accum[index].base = base;
    } else {
      accum.push(tax);
    }

    return accum;
  }, []).map(({ type, amount, ...tax }) => ({
    ...tax,
    type: 'transfer',
    amount: tax.factorType !== 'Exento' ? amount : null,
  }));

  return dataTransfers.map(this.completeDocumentTaxes);
}

function createRetainedDocumentRelated(concepts) {
  const plain = concepts.reduce((accum, { retainedTaxes = [] }) => accum.concat(
    retainedTaxes.map(({ ...props }) => props),
  ), []);

  const dataRetained = plain.reduce((accum, tax) => {
    const index = accum.findIndex(
      currentTax => currentTax.tax === tax.tax && currentTax.fee === tax.fee,
    );

    if (index >= 0) {
      const taxItem = accum[index];

      const amount = parseFloat(taxItem.amount || 0) + parseFloat(tax.amount || 0);
      const base = parseFloat(taxItem.base || 0) + parseFloat(tax.base || 0);

      accum[index].amount = amount;
      accum[index].base = base;
    } else {
      accum.push(tax);
    }

    return accum;
  }, []).map(({ type, ...tax }) => ({ ...tax, type: 'retained' }));

  return dataRetained.map(this.completeDocumentTaxes);
}

function setObjectImpDr(concepts) {
  let objectImpDr = SubjectToTaxTypes.NotTaxObject;

  const hasTaxes = concepts.some(
    concept => concept.subjectToTax === SubjectToTaxTypes.EnableTaxObject
      || concept.taxTransfers
      || concept.retainedTaxes,
  );

  if (hasTaxes) {
    objectImpDr = SubjectToTaxTypes.EnableTaxObject;
  } else {
    const exemptFromtaxes = concepts.every(
      concept => concept.subjectToTax === SubjectToTaxTypes.EnableTaxObjectWithoutBreakDown,
    );

    if (exemptFromtaxes) {
      objectImpDr = SubjectToTaxTypes.EnableTaxObjectWithoutBreakDown;
    }
  }

  return objectImpDr;
}

const paymentsHelper = {
  documentTemplate,
  completeDocumentTaxes,
  createTransfersDocumentRelated,
  createRetainedDocumentRelated,
  setObjectImpDr,
};

export default paymentsHelper;
